import React, { Component } from 'react';
import './Style.css';
import NotFound from '../../../images/empty.svg'

export class PlanTopic extends Component {

    constructor(props) {
        super(props);
        this.state = {
            topicId: window.location.href.substring(window.location.href.lastIndexOf('/') + 1),
            plans: {
                plans: []
            }
        }

    }

    componentDidMount() {
        this.GetPlansByTopic();
    }

    async GetPlansByTopic() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetPlanByTopic?topicId=${this.state.topicId}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ plans: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los planes por tema',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async InsertPlanToUser(activity) {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },

            body: JSON.stringify({
                PlanId: this.state.selectedPlanId,
                Activity: activity
            })
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/InsertPlanToUser`, request);

        this.setState({ loading: false });
        document.querySelector('#btnCloseAddPlan').click();

        if (response.status == 200) {

            const data = await response.json();
            window.location.href = `/comunidad/plan/detalle/${data.id}`;

            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'Te has activado a este plan correctamente',
                    Type: 'alert-success',
                    Show: true
                }
            });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No se puedo registrar el plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    render() {

        return (
            <div className="mt-5">

                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/comunidad">Inicio</a></li>
                        <li class="breadcrumb-item"><a href="/comunidad/plan">Planes</a></li>
                        <li class="breadcrumb-item active" aria-current="page">{this.state.plans.title}</li>
                    </ol>
                </nav>

                <h2 className="mb-5 text-center ">{this.state.plans.title}</h2>
                {
                    this.state.plans.plans.length == 0 ?
                        <div className="align-middle text-center">
                            <img className="not-found" src={NotFound} />
                            <h4 className="mt-5">No hay planes para esta área</h4>
                            <a href="/comunidad/plan">Volver</a>
                        </div>
                        : null
                }

                <div class="row my-plans mt-5">
                    <div class="col-12">
                    </div>
                    <div class="col-12">
                        <ul class="list-group">
                            {this.state.plans ? this.state.plans.plans.map(e =>
                                <li class="list-group-item d-flex align-items-center ecard-plan">
                                    <div class="image-parent">
                                       <img src={e.photo} class="img-fluid mi-plan" alt={e.title} />
                                    </div>
                                    <div className="no-flex ml-4">
                                        <span className="small">Días {e.numberOfDays}</span><br />
                                        <label>{e.title}</label>
                                    </div>
                                    <div className="no-flex ml-4 button-plan-more">
                                        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#subscribePlanModal" onClick={() => {
                                            this.setState({ selectedPlanId: e.id });
                                        }} >
                                            Iniciar
                                        </button>
                                    </div>
                                </li>

                            ) : null
                            }
                        </ul>
                    </div>
                </div>

                <div class="modal fade" id="subscribePlanModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Seguir plan</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                ¿Deseas que la comunidad vea la actividad de tú plan?
                            </div>
                            <div class="modal-footer">

                                <a href="javascript:void(0);" onClick={() => {
                                    this.InsertPlanToUser('Friends');
                                }}>Visible para amigos</a>

                                <a href="javascript:void(0);" onClick={() => {
                                    this.InsertPlanToUser('Private');
                                }}>Privado</a>

                                <a href="javascript:void(0);" id="btnCloseAddPlan" data-dismiss="modal">Cancelar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
